import forge from 'node-forge';
import format from 'date-fns/format';
import { PAYMENT_TYPE,TX_KEY_LENGTH, PAYMENT_PARAMS_DATE_FORMAT} from './constant';

const getTransKey = (txRef) => {
  // const jwtToken = JSON.parse(atob(txToken.split('.')[1]));
  return txRef || '';
}

const getPaymentSalt = (txRef) => {
  let transKey  = String(getTransKey(txRef));
  let salt = '';
  if(transKey.length > TX_KEY_LENGTH){
    salt = transKey.split("").reverse().join(""); ;
  }else{
    const saltStep1 = `${transKey}${transKey}`;
     const saltStep2 =  BigInt(saltStep1); 
    // BUG: Using parseInt() causes a precision loss (truncation) on the final digit of the 'finalSalt' BigInt value.
    // This mismatch with the Backend (BE) payload triggers a 'Data integrity issue' and subsequent payment failure.
    // RESOLUTION: Migrated from parseInt() to BigInt() to securely handle 64-bit integer precision.
    salt =  String(BigInt(saltStep2 * saltStep2));
  }
  return salt;
}

const isNotNull = (variable) => {
  return (typeof variable !== 'undefined' && variable !== null && variable !== '') ? true : false;
}

// For Domestic, UK domestic, International, SEPA payments
const getOtherPaymentParameters = (paymentDetails, enableStructuredAddress = false) => {
  let parameters = [];

  // fromAccount
  if(paymentDetails && paymentDetails.fromAccount){
    paymentDetails.fromAccount.pfId && parameters.push(paymentDetails.fromAccount.pfId);
    paymentDetails.fromAccount.accNo && parameters.push(paymentDetails.fromAccount.accNo);
    paymentDetails.fromAccount.accName && parameters.push(paymentDetails.fromAccount.accName);
    paymentDetails.fromAccount.currency && parameters.push(paymentDetails.fromAccount.currency);
    isNotNull(paymentDetails.fromAccount.accBalance) && parameters.push(String(paymentDetails.fromAccount.accBalance));
    paymentDetails.fromAccount.asOfDate && parameters.push(paymentDetails.fromAccount.asOfDate);
    paymentDetails.fromAccount.psPosId && parameters.push(String(paymentDetails.fromAccount.psPosId));
    paymentDetails.fromAccount.ibanNo && parameters.push(paymentDetails.fromAccount.ibanNo);
    paymentDetails.fromAccount.module && parameters.push(paymentDetails.fromAccount.module);
    paymentDetails.fromAccount.bpId && parameters.push(paymentDetails.fromAccount.bpId);
  }

  // toAccount
  if(paymentDetails && paymentDetails.toAccount){
    paymentDetails.toAccount.accountKey && parameters.push(String(paymentDetails.toAccount.accountKey));
    paymentDetails.toAccount.firstName && parameters.push(paymentDetails.toAccount.firstName);
    paymentDetails.toAccount.lastName && parameters.push(paymentDetails.toAccount.lastName);
    paymentDetails.toAccount.address1 && parameters.push(paymentDetails.toAccount.address1);
    paymentDetails.toAccount.address2 && parameters.push(paymentDetails.toAccount.address2);
    paymentDetails.toAccount.address3 && parameters.push(paymentDetails.toAccount.address3);
    paymentDetails.toAccount.cityName && parameters.push(paymentDetails.toAccount.cityName);
    paymentDetails.toAccount.stateName && parameters.push(paymentDetails.toAccount.stateName);
    paymentDetails.toAccount.country && parameters.push(paymentDetails.toAccount.country);
    paymentDetails.toAccount.postalCode && parameters.push(paymentDetails.toAccount.postalCode);
    paymentDetails.toAccount.accountNo && parameters.push(paymentDetails.toAccount.accountNo);
    paymentDetails.toAccount.ibanNo && parameters.push(paymentDetails.toAccount.ibanNo);
    paymentDetails.toAccount.bankRefId && parameters.push(paymentDetails.toAccount.bankRefId);
    paymentDetails.toAccount.bank && parameters.push(paymentDetails.toAccount.bank);
    paymentDetails.toAccount.swiftCode && parameters.push(paymentDetails.toAccount.swiftCode);
    paymentDetails.toAccount.ntnlId && parameters.push(paymentDetails.toAccount.ntnlId);
    paymentDetails.toAccount.avaloqBankId && parameters.push(paymentDetails.toAccount.avaloqBankId);
    paymentDetails.toAccount.bpId && parameters.push(paymentDetails.toAccount.bpId);
    paymentDetails.toAccount.sortCode && parameters.push(paymentDetails.toAccount.sortCode);
    paymentDetails.toAccount.accountType && parameters.push(paymentDetails.toAccount.accountType);
    if (enableStructuredAddress && paymentDetails.toAccount.beneficiaryAddress) {
      paymentDetails.toAccount.beneficiaryAddress.city && parameters.push(paymentDetails.toAccount.beneficiaryAddress.city);
      paymentDetails.toAccount.beneficiaryAddress.country && parameters.push(paymentDetails.toAccount.beneficiaryAddress.country);
      paymentDetails.toAccount.beneficiaryAddress.street && parameters.push(paymentDetails.toAccount.beneficiaryAddress.street);
      paymentDetails.toAccount.beneficiaryAddress.buildingNo && parameters.push(paymentDetails.toAccount.beneficiaryAddress.buildingNo);
      paymentDetails.toAccount.beneficiaryAddress.postCode && parameters.push(paymentDetails.toAccount.beneficiaryAddress.postCode);
    }
  }

  // currency
  if(paymentDetails && paymentDetails.currency){
    paymentDetails.currency.currencyKey && parameters.push(String(paymentDetails.currency.currencyKey));
    paymentDetails.currency.currencyId && parameters.push(String(paymentDetails.currency.currencyId));
    paymentDetails.currency.isoCode && parameters.push(paymentDetails.currency.isoCode);
    paymentDetails.currency.currencyName && parameters.push(paymentDetails.currency.currencyName);
    paymentDetails.currency.ebLabelDesc && parameters.push(paymentDetails.currency.ebLabelDesc);
    paymentDetails.currency.branchCode && parameters.push(String(paymentDetails.currency.branchCode));
    paymentDetails.currency.tech && parameters.push(paymentDetails.currency.tech);
    paymentDetails.currency.tradeUnit && parameters.push(paymentDetails.currency.tradeUnit);
  }

  // chargeOption
  if(paymentDetails && paymentDetails.chargeOption){
    paymentDetails.chargeOption.costTypeKey && parameters.push(String(paymentDetails.chargeOption.costTypeKey));
    paymentDetails.chargeOption.costType && parameters.push(paymentDetails.chargeOption.costType);
    paymentDetails.chargeOption.costDesc && parameters.push(paymentDetails.chargeOption.costDesc);
    paymentDetails.chargeOption.ebLabelDesc && parameters.push(paymentDetails.chargeOption.ebLabelDesc);
  }

  paymentDetails && isNotNull(paymentDetails.amount) && parameters.push(String(paymentDetails.amount));
  paymentDetails && paymentDetails.executionDate && parameters.push(paymentDetails.executionDate);
  paymentDetails && paymentDetails.remarks && parameters.push(paymentDetails.remarks);
  paymentDetails && paymentDetails.businessUnitBankDate && parameters.push(paymentDetails.businessUnitBankDate);
  paymentDetails && paymentDetails.orderId && parameters.push(paymentDetails.orderId);
  paymentDetails && paymentDetails.versionId && parameters.push(paymentDetails.versionId);
  paymentDetails && paymentDetails.externalOrderId && parameters.push(paymentDetails.externalOrderId);
  paymentDetails && paymentDetails.currencyCode && parameters.push(paymentDetails.currencyCode);
  paymentDetails && paymentDetails.selectedChargeOption && parameters.push(paymentDetails.selectedChargeOption);
  paymentDetails && paymentDetails.transactionFee && parameters.push(paymentDetails.transactionFee);
  paymentDetails && paymentDetails.forexText && parameters.push(paymentDetails.forexText);

  let strParameter = parameters.join('|');
  return strParameter;
}

const getInternalPaymentParameters = (paymentDetails) => {
  let parameters = [];

  // fromAccount
  if(paymentDetails && paymentDetails.fromAccount){
    paymentDetails.fromAccount.pfId && parameters.push(paymentDetails.fromAccount.pfId);
    paymentDetails.fromAccount.accNo && parameters.push(paymentDetails.fromAccount.accNo);
    paymentDetails.fromAccount.accName && parameters.push(paymentDetails.fromAccount.accName);
    paymentDetails.fromAccount.currency && parameters.push(paymentDetails.fromAccount.currency);
    isNotNull(paymentDetails.fromAccount.accBalance) && parameters.push(String(paymentDetails.fromAccount.accBalance));
    paymentDetails.fromAccount.asOfDate && parameters.push(paymentDetails.fromAccount.asOfDate);
    paymentDetails.fromAccount.psPosId && parameters.push(String(paymentDetails.fromAccount.psPosId));
    paymentDetails.fromAccount.ibanNo && parameters.push(paymentDetails.fromAccount.ibanNo);
    paymentDetails.fromAccount.module && parameters.push(paymentDetails.fromAccount.module);
    paymentDetails.fromAccount.bpId && parameters.push(paymentDetails.fromAccount.bpId);
  }

  // toAccount
  if(paymentDetails && paymentDetails.toAccount){
    paymentDetails.toAccount.pfId && parameters.push(paymentDetails.toAccount.pfId);
    paymentDetails.toAccount.accNo && parameters.push(paymentDetails.toAccount.accNo);
    paymentDetails.toAccount.accName && parameters.push(paymentDetails.toAccount.accName);
    paymentDetails.toAccount.currency && parameters.push(paymentDetails.toAccount.currency);
    isNotNull(paymentDetails.toAccount.accBalance) && parameters.push(String(paymentDetails.toAccount.accBalance));
    paymentDetails.toAccount.asOfDate && parameters.push(paymentDetails.toAccount.asOfDate);
    paymentDetails.toAccount.psPosId && parameters.push(String(paymentDetails.toAccount.psPosId));
    paymentDetails.toAccount.ibanNo && parameters.push(paymentDetails.toAccount.ibanNo);
    paymentDetails.toAccount.module && parameters.push(paymentDetails.toAccount.module);
    paymentDetails.toAccount.bpId && parameters.push(paymentDetails.toAccount.bpId);
  }

  // currency
  if(paymentDetails && paymentDetails.currency){
    paymentDetails.currency.currencyKey && parameters.push(String(paymentDetails.currency.currencyKey));
    paymentDetails.currency.currencyId && parameters.push(String(paymentDetails.currency.currencyId));
    paymentDetails.currency.isoCode && parameters.push(paymentDetails.currency.isoCode);
    paymentDetails.currency.currencyName && parameters.push(paymentDetails.currency.currencyName);
    paymentDetails.currency.ebLabelDesc && parameters.push(paymentDetails.currency.ebLabelDesc);
    paymentDetails.currency.branchCode && parameters.push(String(paymentDetails.currency.branchCode));
    paymentDetails.currency.tech && parameters.push(paymentDetails.currency.tech);
    paymentDetails.currency.tradeUnit && parameters.push(paymentDetails.currency.tradeUnit);
  }

  paymentDetails && paymentDetails.paymentKey && parameters.push(String(paymentDetails.paymentKey));
  paymentDetails && isNotNull(paymentDetails.amount) && parameters.push(String(paymentDetails.amount));
  paymentDetails && paymentDetails.executionDate && parameters.push(paymentDetails.executionDate);
  paymentDetails && paymentDetails.remarks && parameters.push(paymentDetails.remarks);
  paymentDetails && paymentDetails.businessUnitBankDate && parameters.push(paymentDetails.businessUnitBankDate);
  paymentDetails && paymentDetails.orderId && parameters.push(paymentDetails.orderId);
  paymentDetails && paymentDetails.versionId && parameters.push(paymentDetails.versionId);
  paymentDetails && paymentDetails.externalOrderId && parameters.push(paymentDetails.externalOrderId);
  paymentDetails && paymentDetails.forexText && parameters.push(paymentDetails.forexText);

  let strParameter = parameters.join('|');
  return strParameter;
}

const getPaymentParametersByType = (paymentDetail, paymentType, enableStructuredAddress = false) => {
  return (paymentType === PAYMENT_TYPE.INTERNAL) ? getInternalPaymentParameters(paymentDetail) : getOtherPaymentParameters(paymentDetail, enableStructuredAddress);
}

export const getPaymentDigest = (txRef, paymentDetail, paymentType, enableStructuredAddress = false) => {

  const salt = getPaymentSalt(txRef);
  const paymentParam = getPaymentParametersByType(paymentDetail, paymentType, enableStructuredAddress);

  var md = forge.md.sha256.create();
  md.update(forge.util.encodeUtf8(paymentParam));
  md.update(salt);
  const paymentDigest = md.digest().toHex();
  return paymentDigest;
}

export function getPaymentReasonToDisplay(paymentReasonList, payReasonKey) {
  let reasonDisplay = '';
  for (let i = 0; i < paymentReasonList.length; i++) {
    const item = paymentReasonList[i];
    if (item.payReasonKey.toString() === payReasonKey.toString()) {
      reasonDisplay = item.ebLabelDesc;
      break;
    }
  }
  return reasonDisplay;
}